import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable  } from 'rxjs';
import { catchError, tap, share } from 'rxjs/operators';

import { AppConfig } from '@solar/app.config';
import { User } from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';
import { Company, Site } from 'solar-bo';

@Injectable({
  providedIn: 'root'
})
export class VerifierService {
  private apiUrl = AppConfig.API_ENDPOINT;  // URL to web api
  constructor(  private http: HttpClient
    ,private errorcontrolservice: ErrorcontrolService){}


  getCompanyExternal(id: string): Observable<Company> {
    this.errorcontrolservice.log(`getCompanyExternal called id=${id}`);
    const url = `${this.apiUrl}/companies/${id}`;
    return this.http.get<Company>(url,AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`fetched getCompanyExternal id=${id}`)),
      catchError(this.errorcontrolservice.handleError<Company>(`getCompanyExternal id=${id}`))
    );
  }

  getVerifierCompanies(): Observable<Company[]> {
    let url = `${this.apiUrl}/companies`;
    let filter=`?filter={\"columns\": [\"id\",\"name\"], \"limit\":20, \"offset\":0, \"filter\": \"info->>'company_type'='VERIFIER'\"}`;
    url+=filter;
    return this.http.get<Company[]>(url,AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`fetched getVerifierCompanies `)),
      catchError(this.errorcontrolservice.handleError<Company[]>(`getVerifierCompanies`))
    );
  }

      /**
     * Return all sites for a company
     * @param company_id 
     * @param filter 
     */
  companySitesGetAll(company_id:any, filter?:string): Observable<Site[]> {
      let url = this.apiUrl + "/companies/" + company_id.id + "/sites/verifier";
      if (filter){
          url=url + "?" + filter;
      }

      return this.http.get<any[]>(url, AppConfig.httpOptions)
          .pipe(
              catchError(this.errorcontrolservice.handleError('companySitesGetAll', []))
              , share()
          );
  } 


  /** PUT: update the user on the server */
  updateCompanyExternal (company: Company): Observable<any> {
    const id = typeof company === 'number' ? company : company.id;
    const url = `${this.apiUrl}/companies/${id}`;

    return this.http.post<Company>(this.apiUrl, company, AppConfig.httpOptions).pipe(
      tap((user: Company) => this.errorcontrolservice.log(`updateCompanyExternal w/ id=${user.id}`)),
      catchError(this.errorcontrolservice.handleError<Company>('updateCompanyExternal'))
    );
  }


  updateCompanyExternal_Role (userid:string, role:any): Observable<any> {
    const id = userid;
    const url = `${this.apiUrl}/setrole/${id}`;

    return this.http.put(url, role, AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`updateUserRole user role id=${userid}`)),
      catchError(this.errorcontrolservice.handleError<any>('updateUserRole'))
    );
  }

  companyVerifierAddSite(verifierId:string, sites): Observable<any> {
    let url = this.apiUrl + "/companies/" + verifierId + "/sites";
    return this.http.post<any>(url, sites, AppConfig.httpOptions).pipe(
        tap(() => this.errorcontrolservice.log(`edit companyVerifierAddSite  w/ id=${verifierId}`)),
        catchError(this.errorcontrolservice.handleError<any>('companyVerifierAddSite'))
    );
}

}
